<!-- 体验官计划页面 -->
<template>
<div class="ambassador-page">
  <Nav :navList="navList"></Nav>
  
  <main class="page">
    <!-- Hero Section -->
    <section class="hero" aria-labelledby="hero-title">
      <div class="hero-media">
        <img src="@/assets/ambassador/pepco-trip-scene.jpeg" alt="PEPCO 小猪班纳户外出行情景图" />
        <span>PEPCO OUTDOOR DAY</span>
      </div>
      <div class="hero-copy">
        <div class="topline">
          <p>小猪班纳体验官计划</p>
          <strong>PEPCO</strong>
        </div>
        <div class="copy-panel">
          <h1 id="hero-title">把夏天穿成出行大片</h1>
          <p>
            审核通过后可获得 PEPCO 夏季新品体验资格。我们邀请亲子家庭在真实场景中完成穿搭拍摄、照片回传，并发布小红书分享。
          </p>
          <div class="pill-row" aria-label="活动关键词">
            <span>SUMMER LOOK</span>
            <span>KIDS STYLE</span>
            <span>REAL SCENE</span>
          </div>
        </div>
        <div class="hero-actions">
          <a class="btn primary" href="#apply">立即申请</a>
          <a class="btn ghost" href="#rules">查看规则</a>
        </div>
      </div>
    </section>

    <!-- Quick Tags -->
    <section class="quick-tags" aria-label="适合拍摄的场景">
      <span>海边出片</span>
      <span>亲子穿搭</span>
      <span>小红书分享</span>
    </section>

    <!-- Grid Section -->
    <section class="section grid-2">
      <article class="card">
        <h2>适合拍摄的场景</h2>
        <div class="tag-row">
          <span>海边</span>
          <span>山野爬山</span>
          <span>网红打卡地</span>
          <span>高铁 / 机场</span>
          <span>公园</span>
          <span>城市街区</span>
          <span>度假酒店</span>
          <span>咖啡店外景</span>
        </div>
      </article>
      <article class="card">
        <h2>申请人需要完成</h2>
        <ul class="clean-list">
          <li>收到夏季体验商品后 7 天内完成拍摄并回传照片</li>
          <li>回传不少于 9 张清晰图片，包含全身、半身、细节和场景图</li>
          <li>发布 1 篇小红书笔记，带指定活动话题</li>
          <li>同意品牌在官方宣传渠道使用回传活动照片</li>
        </ul>
      </article>
    </section>

    <!-- Steps Section -->
    <section class="section card">
      <h2>活动流程</h2>
      <div class="steps">
        <div><b>1</b><span>填写申请表</span></div>
        <div><b>2</b><span>品牌筛选确认</span></div>
        <div><b>3</b><span>寄出夏季商品</span></div>
        <div><b>4</b><span>完成拍摄回传</span></div>
        <div><b>5</b><span>发布小红书笔记</span></div>
        <div><b>6</b><span>品牌确认完成</span></div>
      </div>
    </section>

    <!-- Rules Section -->
    <section class="section" id="rules">
      <div class="section-head">
        <p>RULES</p>
        <h2>申请与拍摄规则</h2>
      </div>
      <div class="rules-grid">
        <article class="card">
          <h3>照片回传要求</h3>
          <ul class="clean-list">
            <li>不少于 9 张清晰照片，建议优先提供竖图原图</li>
            <li>至少 3 张全身穿搭图、3 张半身/细节图、2 张场景氛围图、1 张自由创意图</li>
            <li>体验商品主体需完整露出，能看清版型、颜色、面料和穿搭效果</li>
            <li>不接受低清截图、严重过曝、过度滤镜或 AI 换脸图片</li>
          </ul>
        </article>
        <article class="card">
          <h3>小红书发布要求</h3>
          <ul class="clean-list">
            <li>收到体验商品后 7-10 天内发布 1 篇小红书笔记</li>
            <li>笔记包含至少 4 张上身图片</li>
            <li>标题和正文需体现真实穿搭体验</li>
            <li>带指定话题：#PEPCO小猪班纳体验官 #把夏天穿在路上</li>
          </ul>
        </article>
        <article class="card">
          <h3>合规说明</h3>
          <ul class="clean-list">
            <li>本活动非抽奖、非有奖销售，名额由品牌综合申请资料、拍摄计划与账号内容匹配度筛选</li>
            <li>申请人须为儿童监护人，或已获得儿童监护人授权</li>
            <li>提交信息仅用于活动审核、联系、寄送体验商品及作品回传确认</li>
            <li>如需撤回授权或删除资料，可联系品牌客服处理</li>
          </ul>
        </article>
      </div>
    </section>

    <!-- Apply Form Section -->
    <section class="section form-shell" id="apply">
      <div class="section-head">
        <p>APPLY</p>
        <h2>体验官申请表</h2>
        <span>请填写真实信息。手机号、地址等信息仅用于活动审核、寄送和后续沟通。</span>
      </div>

      <el-form class="apply-form" :model="formData" :rules="formRules" ref="applyFormRef" label-position="top">
        <div class="form-section">
          <h3>基础信息</h3>
          <el-form-item label="姓名 / 昵称 *" prop="name">
            <el-input v-model="formData.name" placeholder="请输入姓名或昵称" />
          </el-form-item>
          <el-form-item label="手机 / 微信 *" prop="contact">
            <el-input v-model="formData.contact" placeholder="用于审核联系" />
          </el-form-item>
          <el-form-item label="所在城市 *" prop="city">
            <el-input v-model="formData.city" placeholder="例如：上海" />
          </el-form-item>
          <el-form-item label="小红书主页链接 *" prop="redbook">
            <el-input v-model="formData.redbook" placeholder="粘贴你的小红书主页链接" />
          </el-form-item>
        </div>

        <div class="form-section">
          <h3>尺码与拍摄计划</h3>
          <el-form-item label="身高 / 体重" prop="bodyInfo">
            <el-input v-model="formData.bodyInfo" placeholder="例如：120cm / 20kg" />
          </el-form-item>
          <el-form-item label="平时穿衣尺码 *" prop="size">
            <el-select v-model="formData.size" placeholder="请选择尺码" style="width: 100%">
              <el-option label="XS" value="XS"></el-option>
              <el-option label="S" value="S"></el-option>
              <el-option label="M" value="M"></el-option>
              <el-option label="L" value="L"></el-option>
              <el-option label="XL" value="XL"></el-option>
              <el-option label="其他/需沟通" value="其他/需沟通"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预计拍摄城市 / 地点 *" prop="shootLocation">
            <el-input v-model="formData.shootLocation" placeholder="例如：青岛海边 / 上海公园" />
          </el-form-item>
          <el-form-item label="是否有摄影师或拍摄搭子" prop="partner">
            <el-select v-model="formData.partner" placeholder="请选择" style="width: 100%">
              <el-option label="有摄影师" value="有摄影师"></el-option>
              <el-option label="有拍摄搭子" value="有拍摄搭子"></el-option>
              <el-option label="可自行完成" value="可自行完成"></el-option>
              <el-option label="暂不确定" value="暂不确定"></el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="form-section">
          <h3>可拍摄场景 *</h3>
          <div class="checkbox-grid">
            <el-checkbox-group v-model="formData.scenes">
              <el-checkbox label="海边">海边</el-checkbox>
              <el-checkbox label="山野爬山">山野爬山</el-checkbox>
              <el-checkbox label="网红打卡地">网红打卡地</el-checkbox>
              <el-checkbox label="高铁/机场">高铁 / 机场</el-checkbox>
              <el-checkbox label="公园">公园</el-checkbox>
              <el-checkbox label="城市街区">城市街区</el-checkbox>
              <el-checkbox label="度假酒店">度假酒店</el-checkbox>
              <el-checkbox label="其他">其他</el-checkbox>
            </el-checkbox-group>
          </div>
          <span v-if="sceneError" class="error-tip">{{ sceneError }}</span>
        </div>

        <div class="form-section">
          <h3>作品与收件信息</h3>
          <el-form-item label="过往作品链接">
            <el-input type="textarea" v-model="formData.portfolio" :rows="4" placeholder="可填写小红书笔记链接、作品集链接等" />
          </el-form-item>
          <el-form-item label="收件人 / 电话 / 地址">
            <el-input type="textarea" v-model="formData.address" :rows="4" placeholder="如希望审核通过后再补充，可填写：审核通过后提供" />
          </el-form-item>
          <el-form-item label="作品图片上传">
            <el-upload
              action="#"
              :auto-upload="false"
              :limit="9"
              multiple
              :on-change="handleImageChange"
              :on-remove="handleImageRemove"
              list-type="picture-card"
              :file-list="fileList"
              accept="image/*"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <span class="upload-tip">最多选择 9 张作品参考图</span>
          </el-form-item>
        </div>

        <div class="notice">
          <el-checkbox-group v-model="agreeChecks">
            <el-checkbox label="rules">我确认已阅读拍摄回传规则，并能在收到夏季体验商品后 7-10 天内完成拍摄、回传和小红书发布。</el-checkbox>
            <el-checkbox label="auth">我同意品牌在官方小红书、朋友圈、社群、详情页、海报等宣传渠道使用我回传的活动照片。</el-checkbox>
            <el-checkbox label="privacy">我确认申请人是儿童监护人或已获得监护人授权，并同意本页面收集的信息用于本次活动审核与联系。</el-checkbox>
          </el-checkbox-group>
          <span v-if="agreeError" class="error-tip">{{ agreeError }}</span>
        </div>

        <el-button class="submit-btn" type="primary" :loading="submitting" @click="handleSubmit">
          提交申请
        </el-button>
        <p class="form-tip" :class="{ success: submitSuccess, error: submitError }">
          {{ formTip }}
        </p>
      </el-form>
    </section>
  </main>
</div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import { ambassadorApplication, uploadAmbassadorImage } from '@/api/web/ambassador'

export default {
  name: 'AmbassadorPage',
  components: { Nav },
  data() {
    return {
      navList: ['体验官计划'],
      formData: {
        name: '',
        contact: '',
        city: '',
        redbook: '',
        bodyInfo: '',
        size: '',
        shootLocation: '',
        partner: '',
        scenes: [],
        portfolio: '',
        address: ''
      },
      formRules: {
        name: [{ required: true, message: '请输入姓名或昵称', trigger: 'blur' }],
        contact: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
        city: [{ required: true, message: '请输入所在城市', trigger: 'blur' }],
        redbook: [{ required: true, message: '请输入小红书主页链接', trigger: 'blur' }],
        size: [{ required: true, message: '请选择尺码', trigger: 'change' }],
        shootLocation: [{ required: true, message: '请输入预计拍摄地点', trigger: 'blur' }]
      },
      fileList: [],
      imageFiles: [],
      agreeChecks: [],
      sceneError: '',
      agreeError: '',
      submitting: false,
      submitSuccess: false,
      submitError: false,
      formTip: ''
    }
  },
  methods: {
    handleImageChange(file, list) {
      this.imageFiles = list.map(item => item.raw)
       const MAX_COUNT = 9; // 暂时注释，排查系统原生选择器9张限制
       if (this.imageFiles.length > MAX_COUNT) {
         this.imageFiles = this.imageFiles.slice(0, 9)
         this.fileList = this.fileList.slice(0, 9)
         this.$message.warning(`最多只能上传 ${MAX_COUNT} 张图片，已自动保留前 ${MAX_COUNT} 张`);
       }
    },
    handleImageRemove(file, list) {
      this.imageFiles = list.map(item => item.raw)
    },
    validateForm() {
      this.sceneError = ''
      this.agreeError = ''
      
      if (!this.formData.scenes || this.formData.scenes.length === 0) {
        this.sceneError = '请选择至少一个可拍摄场景'
        return false
      }
      
      if (!this.agreeChecks.includes('rules')) {
        this.agreeError = '请确认已阅读拍摄回传规则'
        return false
      }
      if (!this.agreeChecks.includes('auth')) {
        this.agreeError = '请确认图片授权说明'
        return false
      }
      if (!this.agreeChecks.includes('privacy')) {
        this.agreeError = '请确认监护人授权与隐私说明'
        return false
      }
      
      return true
    },
    async handleSubmit() {
      // 表单验证
      try {
        await this.$refs.applyFormRef.validate()
      } catch (e) {
        this.formTip = '请填写必填项'
        this.submitError = true
        this.submitSuccess = false
        return
      }
      
      // 自定义验证
      if (!this.validateForm()) {
        return
      }
      
      this.submitting = true
      this.submitSuccess = false
      this.submitError = false
      this.formTip = '正在提交...'
      
      try {
        // ---------- 步骤1：先上传图片 ----------
        let imageUrls = []
        if (this.imageFiles.length > 0) {
          this.formTip = '正在上传图片...'
          
          for (let i = 0; i < this.imageFiles.length; i++) {
            try {
              this.formTip = `正在上传图片 ${i + 1}/${this.imageFiles.length}...`
              const uploadRes = await uploadAmbassadorImage(this.imageFiles[i])
              // 兼容拦截器返回格式
              const uploadData = uploadRes.data || uploadRes
              if (uploadData && uploadData.url) {
                imageUrls.push(uploadData.url)
              } else if (uploadData && uploadData.data && uploadData.data.url) {
                // 后端 Result.success(data) → 拦截器可能返回 data 本身
                imageUrls.push(uploadData.data.url)
              }
            } catch (uploadErr) {
              console.error(`第 ${i + 1} 张图片上传失败:`, uploadErr)
              throw new Error(`第 ${i + 1} 张图片上传失败，请重试`)
            }
          }
        }

        // ---------- 步骤2：构建提交数据 ----------
        this.formTip = '正在提交申请...'
        const submitData = {
          name: this.formData.name,
          contact: this.formData.contact,
          city: this.formData.city,
          redbook: this.formData.redbook || '',
          bodyInfo: this.formData.bodyInfo || '',
          size: this.formData.size || '',
          scenes: JSON.stringify(this.formData.scenes),
          shootLocation: this.formData.shootLocation || '',
          partner: this.formData.partner || '',
          portfolio: this.formData.portfolio || '',
          address: this.formData.address || '',
          portfolioImages: imageUrls.join(','),
          agreeRules: this.agreeChecks.includes('rules'),
          agreeAuth: this.agreeChecks.includes('auth'),
          agreePrivacy: this.agreeChecks.includes('privacy')
        }
        
        // 调用 API
        const response = await ambassadorApplication(submitData)
        
        // 兼容处理：拦截器已返回 response.data（即 Result 对象 {code, message, data}）
        const resData = response
        
        if (resData.code === 200) {
          this.submitSuccess = true
          this.submitError = false
          this.formTip = '申请已提交成功，我们会尽快完成审核并联系你。'
          // 重置表单
          this.$refs.applyFormRef.resetFields()
          this.formData.scenes = []
          this.agreeChecks = []
          this.fileList = []
          this.imageFiles = []
        } else {
          throw new Error(resData.message || '提交失败')
        }
      } catch (error) {
        console.error('提交失败:', error)
        this.submitError = true
        this.submitSuccess = false
        
        // 根据错误类型显示不同提示
        if (error.response?.status === 415) {
          this.formTip = '服务器暂不支持此功能，请联系管理员配置后端接口'
        } else if (error.code === 'ECONNABORTED' || error.message?.includes('Network') || error.message?.includes('timeout')) {
          this.formTip = '网络连接失败，接口未响应，请检查后端服务是否已部署'
        } else if (error.message?.includes('Cannot read')) {
          this.formTip = '系统错误，请稍后再试'
        } else {
          this.formTip = error.message || '提交失败，请稍后再试'
        }
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ambassador-page {
  width: 100%;
  min-height: 100vh;
  background: #eef9ff;
}

// 主内容区：与下方 section 保持统一宽度
.page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 12px 20px 0;
  
  @media (max-width: 768px) {
    padding: 65px 16px 0;
  }
}

// Hero Section - 大卡片包裹左右小卡片，全圆角
.hero {
  display: flex;
  background: #fff;
  color: #173247;
  border-radius: 24px;
  overflow: hidden;
  margin-bottom: 20px;
  box-shadow: 0 12px 40px rgba(19, 96, 150, 0.10);
  
  @media (max-width: 768px) {
    flex-direction: column;
    margin-bottom: 14px;
  }
}

.hero-media {
  flex: 1;
  position: relative;
  overflow: hidden;
  border-radius: 24px 0 0 24px;
  min-height: 300px;
  
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  span {
    position: absolute;
    left: 20px;
    bottom: 18px;
    background: rgba(255,255,255,0.86);
    color: #1479c8;
    padding: 8px 16px;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.08em;
    border-radius: 20px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.08);
    z-index: 2;
  }
  
  @media (max-width: 768px) {
    border-radius: 24px 24px 0 0;
    height: 50vh;
    min-height: 280px;
    
    span {
      left: 12px;
      bottom: 12px;
      font-size: 11px;
      padding: 6px 12px;
    }
  }
}

.hero-copy {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 30px 28px;
  background: #fff;
  
  @media (max-width: 768px) {
    padding: 20px 16px;
  }
}

.topline {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
  
  p {
    font-size: 14px;
    letter-spacing: 3px;
    color: #1479c8;
    font-weight: 700;
  }
  
  strong {
    font-size: 28px;
    font-weight: 900;
    letter-spacing: 4px;
    color: #173247;
  }
}

.copy-panel {
  h1 {
    font-size: 48px;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 20px;
    color: #173247;
    
    @media (max-width: 768px) {
      font-size: 32px;
    }
  }
  
  p {
    font-size: 16px;
    line-height: 1.8;
    color: #557184;
    margin-bottom: 18px;
    
    @media (max-width: 768px) {
      line-height: 1.6;
    }
  }
}

.pill-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 24px;
  
  span {
    padding: 8px 18px;
    border-radius: 20px;
    font-size: 12px;
    letter-spacing: 1.5px;
    color: #1682c4;
    font-weight: 700;
    background: #e8f7ff;
    border: none;
  }
}

.hero-actions {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.btn {
  padding: 14px 36px;
  border-radius: 30px;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 1px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &.primary {
    background: linear-gradient(180deg, #51c7f4, #1b9ad9);
    color: #fff;
    border: none;
    box-shadow: 0 12px 24px rgba(27, 154, 217, 0.22);
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 24px rgba(27, 154, 217, 0.35);
    }
  }
  
  &.ghost {
    background: #fff;
    color: #1479c8;
    border: 1px solid rgba(27, 154, 217, 0.24);
    
    &:hover {
      border-color: #1b9ad9;
      color: #1b9ad9;
      background: #e8f7ff;
    }
  }
}

// Quick Tags - 蓝色品牌风格
.quick-tags {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 16px 0;
  
  span {
    min-height: 44px;
    border-radius: 12px;
    background: #fff;
    color: #1479c8;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 800;
    box-shadow: 0 10px 28px rgba(31, 130, 190, 0.10);
    border: none;
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 8px;
    padding: 14px 0;
    
    span {
      font-size: 14px;
      min-height: 38px;
    }
  }
}

// Section Styles
.section {
  padding: 24px 0;
  
  @media (max-width: 768px) {
    padding: 12px 0;
  }
}

.grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 14px;
  }
}

.card {
  background: rgba(255, 255, 255, 0.94);
  border-radius: 12px;
  padding: 24px;
  border: 1px solid rgba(54, 174, 232, 0.16);
  box-shadow: 0 8px 20px rgba(19, 96, 150, 0.06);
  
  h2 {
    font-size: 20px;
    margin-bottom: 14px;
    color: #1b9ad9;
    font-weight: 700;
  }
  
  h3 {
    font-size: 16px;
    margin-bottom: 12px;
    color: #173247;
  }
  
  @media (max-width: 768px) {
    padding: 12px;
    
    h2 {
      margin-bottom: 10px;
    }
    
    h3 {
      margin-bottom: 8px;
    }
  }
}

.tag-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  
  span {
    padding: 8px 18px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    color: #1682c4;
    background: #e8f7ff;
    border: none;
  }
}

.clean-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 8px;
  
  @media (max-width: 768px) {
    gap: 5px;
  }
  
  li {
    padding: 10px 14px 10px 26px;
    position: relative;
    font-size: 14px;
    line-height: 1.7;
    color: #557184;
    background: rgba(232, 247, 255, 0.5);
    border-radius: 10px;
    
    @media (max-width: 768px) {
      line-height: 1.5;
      padding: 8px 12px 8px 24px;
    }
    
    &::before {
      content: '';
      position: absolute;
      left: 12px;
      top: 1.2em;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #1b9ad9;
    }
  }
}

// Steps - 流程步骤
.steps {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px;
  
  > div {
    text-align: center;
    padding: 12px 8px;
    display: grid;
    justify-items: center;
    gap: 10px;
    
    b {
      width: 44px;
      height: 44px;
      line-height: 44px;
      margin: 0;
      background: linear-gradient(180deg, #51c7f4, #1b9ad9);
      color: #fff;
      border-radius: 50%;
      font-size: 18px;
      font-weight: 700;
      box-shadow: 0 4px 14px rgba(27, 154, 217, 0.25);
    }
    
    span {
      font-size: 13px;
      color: #557184;
      font-weight: 500;
      line-height: 1.5;
      
      @media (max-width: 768px) {
        line-height: 1.4;
      }
    }
  }
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
}

// Rules Grid
.rules-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 20px;
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 11px;
    margin-top: 14px;
  }
}

// Form Shell - 去掉外框背景，干净展示
.form-shell {
  padding: 0;
  margin-bottom: 30px;
  
  @media (max-width: 768px) {
    padding: 0;
  }
}

.section-head {
  text-align: center;
  margin-bottom: 24px;
  
  @media (max-width: 768px) {
    margin-bottom: 16px;
  }
  
  p {
    font-size: 13px;
    letter-spacing: 4px;
    color: #1479c8;
    margin-bottom: 8px;
    font-weight: 900;
  }
  
  h2 {
    font-size: 36px;
    color: #173247;
    margin-bottom: 12px;
    font-weight: 700;
    
    @media (max-width: 768px) {
      font-size: 28px;
      margin-bottom: 8px;
    }
  }
  
  span {
    font-size: 14px;
    color: #557184;
    line-height: 1.6;
    
    @media (max-width: 768px) {
      line-height: 1.5;
    }
  }
}

// 表单区不再有蓝色背景，section-head 使用通用深色样式
.apply-form {
  background: rgba(255, 255, 255, 0.94);
  border-radius: 12px;
  padding: 28px;
  border: 1px solid rgba(54, 174, 232, 0.16);
  box-shadow: 0 8px 20px rgba(19, 96, 150, 0.06);
  
  @media (max-width: 768px) {
    padding: 12px;
    
    ::v-deep .el-form-item {
      margin-bottom: 12px;
    }
    
    ::v-deep .el-form-item__label {
      padding-bottom: 2px;
    }
  }
}

.form-section {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid rgba(54, 174, 232, 0.16);
  
  @media (max-width: 768px) {
    margin-bottom: 16px;
    padding-bottom: 16px;
  }
  
  &:last-of-type {
    border-bottom: none;
    margin-bottom: 30px;
    padding-bottom: 0;
  }
  
  h3 {
    font-size: 17px;
    color: #1b9ad9;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 2px solid rgba(54, 174, 232, 0.16);
    display: inline-block;
    font-weight: 700;
    
    @media (max-width: 768px) {
      margin-bottom: 5px;
      padding-bottom: 4px;
    }
  }
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.upload-tip {
  display: block;
  margin-top: 8px;
  font-size: 12px;
  color: #6d8899;
}

.error-tip {
  display: block;
  color: #1479c8;
  font-size: 13px;
  margin-top: 10px;
  font-weight: 500;
}

// Notice
.notice {
  margin-bottom: 20px;
  
  ::v-deep .el-checkbox {
    display: block;
    margin-bottom: 10px;
    line-height: 1.6;
    
    .el-checkbox__label {
      font-size: 13px;
      color: #557184;
      line-height: 1.6;
      white-space: normal;
      
      @media (max-width: 768px) {
        line-height: 1.5;
      }
    }
  }
}

// Submit Button - 蓝色品牌风格
.submit-btn {
  width: 33.33% !important;
  margin: 0 auto !important;
  display: block !important;
  height: 46px;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 2px;
  background: linear-gradient(180deg, #51c7f4, #1b9ad9);
  border: none;
  border-radius: 30px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 12px 24px rgba(27, 154, 217, 0.22);
  
  @media (max-width: 768px) {
    width: 66.66% !important;
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 32px rgba(27, 154, 217, 0.35);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.form-tip {
  text-align: center;
  margin-top: 12px;
  font-size: 14px;
  color: #6d8899;
  line-height: 1.6;
  
  &.success {
    color: #5BA37A;
    font-weight: 500;
  }
  
  &.error {
    color: #1479c8;
    font-weight: 500;
  }
}
</style>
